import React, { useState } from 'react'
import { Box, Accordion, AccordionSummary, AccordionDetails, Theme, Button } from '@mui/material'
import { makeStyles } from '@mui/styles'
// eslint-disable-next-line import/no-cycle
import { CreateTeamsModal } from '../modals'
import { N1RequestCommand } from '../../../types/default-types'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

export const Teams: React.FC<{
  img: any
  className: any
  expanded: boolean
  updateInfo(): void
  onExpand: () => void
  data: N1RequestCommand[]
}> = ({ data = [], updateInfo, className, img = [], expanded, onExpand = () => {} }): JSX.Element => {
  const classes = useStyles()
  const [createTeamsModal, setCreateTeamsModal] = useState<N1RequestCommand | undefined>(undefined)

  return (
    <>
      <CreateTeamsModal
        request={createTeamsModal}
        onClose={() => {
          setCreateTeamsModal(undefined)
          updateInfo()
        }}
      />

      <Box className={classes.teams}>
        <Accordion id="teams" expanded={expanded} onChange={onExpand} square={false}>
          <AccordionSummary expandIcon={<Icon className={className} img={img} />}>Создание команд</AccordionSummary>
          <AccordionDetails>
            <Box className={className.contentAccordionDetails}>
              {data.map((i: N1RequestCommand, index) => {
                return (
                  <Box key={`teams${index}`} mt={2}>
                    <Button
                      color="secondary"
                      variant="contained"
                      className={classes.btn}
                      disabled={i.requests.length < 4}
                      onClick={() => setCreateTeamsModal(i)}
                    >
                      Создать команду «{i.nomination.name}»
                    </Button>
                  </Box>
                )
              })}
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  )
}

const useStyles = makeStyles(({ spacing, font, breakpoints: { down }, palette }: Theme) => ({
  teams: {},
  btn: {
    fontSize: '16px!important',
    padding: '10px 30px!important',
    minHeight: '35px!important',
    [down('md')]: {
      fontSize: '15px!important',
      padding: '10px 25px!important',
      minHeight: '30px!important',
      [down('md')]: {
        fontSize: '15px!important',
        padding: '10px 25px!important',
        minHeight: '30px!important',
      },
      [down('sm')]: {
        fontSize: '12px!important',
        padding: '10px 15px!important',
        minHeight: '25px!important',
        minWidth: '10px!important',
      },
    },
  },
}))
